(() => {
  'use strict';
  const link=document.querySelector('[data-return-shortcut]');
  if(!link)return;
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  let target,wrapper,marker,previewBar,frame=0,rebind=false;
  const headerHeight=()=>document.querySelector('.site-header')?.offsetHeight||64;
  const observer='ResizeObserver'in window?new ResizeObserver(()=>schedule()):null;
  function previewInset(){
    const bar=document.getElementById('PBarNextFrameWrapper');
    if(bar!==previewBar){
      if(previewBar)observer?.unobserve(previewBar);
      previewBar=bar;
      if(previewBar){observer?.observe(previewBar);previewChanges.observe(previewBar,{attributes:true,attributeFilter:['style','class','hidden']});}
    }
    if(!bar)return 0;
    const style=getComputedStyle(bar),rect=bar.getBoundingClientRect();
    if(style.display==='none'||style.visibility==='hidden'||rect.height<=0||rect.top>=innerHeight)return 0;
    return Math.max(0,Math.min(innerHeight,innerHeight-rect.top));
  }
  function update(){
    link.style.setProperty('--ei-preview-bottom',previewInset()+'px');
    if(!target?.isConnected||!wrapper?.isConnected||!marker?.isConnected){link.hidden=true;return;}
    const watch=target.querySelector('[data-add-button],#find-parts')||target;
    const watched=watch.getBoundingClientRect();
    const distance=watched.height>0?watched.bottom-wrapper.getBoundingClientRect().top:wrapper.offsetHeight;
    const start=marker.getBoundingClientRect().top+window.scrollY;
    link.hidden=window.scrollY+headerHeight()+24<start+distance;
  }
  function bind(){
    observer?.disconnect();previewBar=null;
    target=document.getElementById(link.dataset.returnTarget);
    wrapper=target?.closest('.shopify-section');
    if(!target||!wrapper){marker?.remove();marker=null;link.hidden=true;return;}
    if(!marker?.isConnected){
      marker=document.createElement('span');
      marker.className='ei-return-marker';
      marker.setAttribute('aria-hidden','true');
    }
    wrapper.before(marker);
    observer?.observe(wrapper);
    update();
  }
  function schedule(refresh=false){
    if(refresh===true)rebind=true;
    if(frame)return;
    frame=requestAnimationFrame(()=>{frame=0;if(rebind){rebind=false;bind();}else update();});
  }
  link.addEventListener('click',event=>{
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(!target?.isConnected||!marker?.isConnected)return;
    event.preventDefault();
    const top=Math.max(0,marker.getBoundingClientRect().top+window.scrollY-headerHeight()-16);
    history.replaceState(null,'',link.getAttribute('href'));
    target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
    window.scrollTo({top,behavior:reduced.matches?'auto':'smooth'});
  });
  const previewChanges=new MutationObserver(()=>schedule());
  previewChanges.observe(document.body,{childList:true});
  window.addEventListener('scroll',()=>schedule(),{passive:true});
  window.addEventListener('resize',()=>schedule(),{passive:true});
  window.addEventListener('pageshow',()=>schedule());
  ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(name=>document.addEventListener(name,()=>schedule(true)));
  bind();
})();
